/**
 * Stop/slowdown hitting services with every keypress
 * @see https://davidwalsh.name/function-debounce
 */
export function debounce(fn, delay) {
    let timeoutID = null;
    return function() {
        clearTimeout(timeoutID);
        let args = arguments;
        let that = this;
        timeoutID = setTimeout(function () {
            fn.apply(that, args);
        }, delay);
    };
}